import { defineMessages } from 'react-intl';

export const yakliMessages = defineMessages({
  subtitlePrefix: { defaultMessage: 'Linked to the topic:', id: 'x5L8yc' },
  allDiscussions: { defaultMessage: 'All discussions', id: 'mfC2Ez' },
  uniqueDiscussion: { defaultMessage: 'Single discussion', id: 'eRP1Xh' },
  copySuccess: { defaultMessage: 'The link to the message has been copied.', id: 'rDQvwg' },
  discussionPageName: { defaultMessage: 'Discussion', id: '20bImY' },
});
